import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { coerceNumber } from '@partners/utils';
import { IRangeValidationHandler, TValidatorError } from '../../model';

export function minNumericValidator(args: Partial<IRangeValidationHandler<number>>): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value, invalid } = control;
    const { min } = args;

    if (invalid) return null;

    const validNumber = coerceNumber(value);
    if (!validNumber && validNumber !== 0) {
      return null;
    }

    if (validNumber < min) {
      const vldResponse: TValidatorError = { minNumber: value };
      return vldResponse;
    }

    return null;
  };
}
